module.exports = __webpack_public_path__ + "img/thumb-gebakken-gehaktburgers-met-italiaanse-kruiden.189d1ed4.jpeg";